import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BundleAdvanced } from 'src/app/services/labpartner.service.model';
import { ExperimentService } from 'src/app/shared/experiment.service';

export interface AdvancedBundleDialogData {
  bundleAdvanced?: BundleAdvanced;
  isEditMode?: boolean;
}

@Component({
  selector: 'app-advanced-bundle-dialog',
  templateUrl: './advanced-bundle-dialog.component.html',
  styleUrls: ['./advanced-bundle-dialog.component.scss'],
  standalone: false,
})
export class AdvancedBundleDialogComponent implements OnInit {
  advancedBundleForm!: UntypedFormGroup;
  devices: any[] = [];
  isLoading = false;

  constructor(
    private dialogRef: MatDialogRef<AdvancedBundleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AdvancedBundleDialogData,
    private experimentService: ExperimentService,
  ) {
    // Only allow Sofia2 (id: 1) and Savanna (id: 2) for Advanced Bundles
    this.devices = this.experimentService.devices.filter(
      device => device.id === 1 || device.id === 2,
    );
  }

  ngOnInit(): void {
    this.initializeForm();
  }

  private initializeForm(): void {
    this.advancedBundleForm = new UntypedFormGroup({
      name: new UntypedFormControl(this.data.bundleAdvanced?.bundle?.name || '', [
        Validators.required,
        Validators.maxLength(100),
      ]),
      deviceType: new UntypedFormControl(this.data.bundleAdvanced?.deviceType || null, [
        Validators.required,
      ]),
      description: new UntypedFormControl(this.data.bundleAdvanced?.description || '', [
        Validators.maxLength(500),
      ]),
    });
  }

  onSubmit(): void {
    if (this.advancedBundleForm.valid) {
      this.isLoading = true;

      const formValue = this.advancedBundleForm.value;
      const bundleAdvanced: BundleAdvanced = {
        bundleId: this.data.bundleAdvanced?.bundleId || 0,
        description: formValue.description,
        deviceType: formValue.deviceType,
        bundle: {
          bundleId: this.data.bundleAdvanced?.bundleId || 0,
          name: formValue.name,
          bundleType: 2, // Advanced Bundle Type (0=Serial, 1=Experiment, 2=Advanced)
          instrumentSerialNumbers: '',
          instrumentSerialNumbersCount: '',
          experimentIds: '',
          experimentIdsCount: 0,
          assayTypeCode: '',
          startDate: new Date(),
          endDate: new Date(),
          dateCreated: this.data.bundleAdvanced?.bundle?.dateCreated || new Date(),
          createdBy: this.data.bundleAdvanced?.bundle?.createdBy || 0,
          isClinicalTrial: false,
          isUsedToGenerateReport: false,
        },
      };

      this.dialogRef.close({
        ok: true,
        data: bundleAdvanced,
      });
    }
  }

  onCancel(): void {
    this.dialogRef.close({ ok: false });
  }

  getDeviceName(id: number): string {
    return this.experimentService.getDeviceName(id);
  }
}
